"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveCollapseState = exports.getIdForMenuItem = void 0;
/**
 * Returns the id for a menu item.
 */
function getIdForMenuItem(item) {
    if (!item.label) {
        return null;
    }
    if (typeof item.label === 'string') {
        return item.label;
    }
    return item.label.props.id;
}
exports.getIdForMenuItem = getIdForMenuItem;
/**
 * Derives the collapse state for a set of menu items.
 *
 * Defaults to all items being collapsed.
 */
function deriveCollapseState(items) {
    const itemKeys = [];
    // recursively gather all keys
    const gatherKeys = (items) => {
        items.forEach((item) => {
            if (item.items) {
                const id = getIdForMenuItem(item);
                if (id) {
                    itemKeys.push(id);
                }
                gatherKeys(item.items);
            }
        });
    };
    gatherKeys(items);
    return itemKeys.reduce((acc, key) => {
        acc[key] = false;
        return acc;
    }, {});
}
exports.deriveCollapseState = deriveCollapseState;
//# sourceMappingURL=drawer-utils.js.map